import { FC, useCallback } from 'react';
import { useSnapshot } from 'valtio';
import { Nullable } from 'common-types';
import { navigateToConnectors } from '../../common/routing/app-navigator';
import { IssueDetails } from '../../issues/common/types/issues-types';
import PermissionDeniedForm from '../components/PermissionDeniedForm';
import QuickFixModal from '../components/QuickFixModal';
import QuickFixStore from '../stores/quick-fix-store';

const PermissionDeniedModalContainer: FC<
  PermissionDeniedModalContainerProps
> = props => {
  const { errorMessage } = useSnapshot(QuickFixStore);
  const { open, onClose, selectedIssue } = props;

  const modalHeader = 'Permission Denied';

  const onNavigate = useCallback(() => {
    onClose();
    navigateToConnectors();
  }, [onClose]);

  if (!errorMessage || !selectedIssue) {
    return null;
  }

  return (
    <QuickFixModal open={open} onClose={onClose} modalHeader={modalHeader}>
      <PermissionDeniedForm
        open={open}
        selectedIssue={selectedIssue}
        errorMessage={errorMessage}
        onClose={onClose}
        onNavigate={onNavigate}
      />
    </QuickFixModal>
  );
};

interface PermissionDeniedModalContainerProps {
  onClose: () => void;
  open: boolean;
  selectedIssue: Nullable<IssueDetails>;
}

export default PermissionDeniedModalContainer;
